<template>
  <div class="data-container">
    <div v-if="verify">
      <!-- 主标题和时间 -->
      <van-cell-group class="data-group">
        <van-cell title="活动数据统计看板" :value="formattedDate" />
      </van-cell-group>

      <!-- 嘉宾报名数据 -->
      <van-panel title="1. 嘉宾报名数据" desc="当前报名人数统计" class="data-panel">
        <div class="ai-data-container">
          <van-cell
              v-for="(item, index) in guestDataItems"
              :key="'guest-'+index"
              :title="item.label"
              :value="totalData[totalKey[item.key]]"
              :border="index !== guestDataItems.length - 1"
          />
        </div>
        <div class="button-container">
          <van-button
              round
              type="primary"
              size="small"
              @click="copyTotalContext"
              icon="copy"
          >复制报名数据</van-button>
        </div>
      </van-panel>

      <!-- 嘉宾审核数据 -->
      <van-panel title="2. 嘉宾审核进度" desc="已审核/总报名数" class="data-panel">
        <div class="ai-data-container">
          <van-cell
              v-for="(item, index) in guestDataItems"
              :key="'audit-'+index"
              :title="item.label"
              :label="`(已审核 ${totalData.successCounts[totalKey[item.key]] || 0} / 总报名 ${totalData[totalKey[item.key]]})`"
              :border="index !== guestDataItems.length - 1"
          />
        </div>
        <div class="button-container">
          <van-button
              round
              type="info"
              size="small"
              @click="copyAuditContext"
              icon="copy"
          >复制审核数据</van-button>
        </div>
      </van-panel>

      <!-- 工作人员数据 -->
      <van-panel title="3. 工作人员数据" desc="工作人员报名统计" class="data-panel">
        <div class="ai-data-container">
          <van-cell
              v-for="(item, index) in guestDataItems"
              :key="'work-'+index"
              :title="item.label"
              :value="workTotalData[totalKey[item.key]]"
              :border="index !== guestDataItems.length - 1"
          />
          <van-cell
              title="工作人员总数"
              :value="workTotalData[totalKey.total]"
              class="total-cell"
          />
        </div>
        <div class="button-container">
          <van-button
              round
              type="warning"
              size="small"
              @click="copyWorkTotalContext"
              icon="copy"
          >复制工作人员数据</van-button>
        </div>
      </van-panel>
    </div>

    <!-- 密码验证部分 -->
    <div v-else class="password-container">
      <van-image
          src="https://fastly.jsdelivr.net/npm/@vant/assets/logo.png"
          width="100"
          height="100"
          class="logo"
      />
      <h2 class="login-title">数据看板登录</h2>
      <p class="login-subtitle">请输入密码查看活动数据</p>
      <van-cell-group>
        <van-field
            v-model="password"
            type="password"
            label="访问密码"
            placeholder="请输入访问密码"
            clearable
        />
      </van-cell-group>
      <div class="button-container">
        <van-button
            round
            type="primary"
            size="normal"
            @click="verifyPassword"
            block
        >确认登录</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { basicRequest } from "@/utils/http";
import { Toast } from "vant";

export default {
  data() {
    return {
      verify: false,
      password: "",
      guestDataItems: [
        { label: "开幕式|岳麓论坛", key: "key10" },
        { label: "大学生创新创业", key: "key1" },
        { label: "AI+创新生态", key: "key2" },
        { label: "AI+文化", key: "key3" },
        { label: "AI+智能网联", key: "key4" },
        { label: "AI+工业互联网", key: "key5" },
        { label: "AI+营商环境", key: "key6" },
        { label: "AI+城市治理", key: "key7" },
        { label: "AI+新材料", key: "key8" },
        { label: "AI+数字教育", key: "key9" }
      ],
      totalKey: {
        key1: "b67a34cc52ad4429b1111c727e315436",
        key2: "09904e69cd9a4040bbd88b0a5e18f82f",
        key3: "83544effc0d24f478a08fb43ba829d47",
        key4: "8056400d7533406a8152b8e874ff920e",
        key5: "8e6044db3ebd4a559565bfbf388352c1",
        key6: "4e2d65640b5b4caeb3873109744342bc",
        key7: "d530a44915e74cce81c6fe160ee3c5f8",
        key8: "cee3654463464872b9ac522b5a4c28a7",
        key9: "6d354390bd304ccab26464bce7b1f68d",
        key10: "a5a4243c40d74147b006191889bd039b",
        total: "allTotal",
      },
      totalData: {},
      workTotalData: {},
    };
  },
  computed: {
    formattedDate() {
      return this.$moment().format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    verifyPassword() {
      if (this.password !== "2025") {
        Toast.fail("密码错误，请重试");
        return;
      }
      this.verify = true;
      this.getTotalData();
      this.getWorkTotalData();
    },
    getTotalData() {
      this.$http.get("/api/backstageApply/statistics").then((res) => {
        this.totalData = res;
      });
    },
    getWorkTotalData() {
      this.$http.get("/api/backstageApply/statistics?type=1").then((res) => {
        this.workTotalData = res;
      });
    },
    async copyTotalContext() {
      const text = `截止${this.formattedDate}嘉宾报名数据：
开幕式|岳麓论坛：(${this.totalData[this.totalKey.key10]})
大学生创新创业：(${this.totalData[this.totalKey.key1]})
AI+创新生态：(${this.totalData[this.totalKey.key2]})
AI+文化：(${this.totalData[this.totalKey.key3]})
AI+智能网联：(${this.totalData[this.totalKey.key4]})
AI+工业互联网：(${this.totalData[this.totalKey.key5]})
AI+营商环境：(${this.totalData[this.totalKey.key6]})
AI+城市治理：(${this.totalData[this.totalKey.key7]})
AI+新材料：(${this.totalData[this.totalKey.key8]})
AI+数字教育：(${this.totalData[this.totalKey.key9]})
企业总报名数：(${this.totalData['companyCount']})   嘉宾总报名人数：(${this.totalData['guestCount']})（筛除重复企业和嘉宾）
`;
      try {
        await navigator.clipboard.writeText(text);
        Toast.success("嘉宾报名数据已复制到剪贴板！");
      } catch {
        Toast.fail("复制失败，请重试");
      }
    },
    async copyWorkTotalContext() {
      const items = this.guestDataItems.map(item =>
          `${item.label}：${this.workTotalData[this.totalKey[item.key]]}`
      ).join('\n');

      const text = `截止${this.formattedDate}工作人员报名数据：
${items}
工作人员总数：${this.workTotalData[this.totalKey.total]}`;

      try {
        await navigator.clipboard.writeText(text);
        Toast.success("工作人员数据已复制到剪贴板！");
      } catch {
        Toast.fail("复制失败，请重试");
      }
    },
    async copyAuditContext() {
      const items = this.guestDataItems.map(item =>
          `${item.label}：（已审核 ${this.totalData.successCounts[this.totalKey[item.key]] || 0} / 总报名 ${this.totalData[this.totalKey[item.key]]}）`
      ).join('\n');

      const text = `截止${this.formattedDate}嘉宾审核数据：
${items}`;

      try {
        await navigator.clipboard.writeText(text);
        Toast.success("审核数据已复制到剪贴板！");
      } catch {
        Toast.fail("复制失败，请重试");
      }
    },
  },
};
</script>

<style scoped>
.data-container {
  padding: 12px;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.data-group {
  margin-bottom: 16px;
}

.data-group .van-cell__title {
  font-size: 18px;
  font-weight: bold;
}

.data-panel {
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.data-panel .van-panel__header {
  background-color: #f0f7ff;
}

.data-panel .van-panel__header-panel .van-panel__header .van-panel__title {
  font-weight: bold;
  color: #1989fa;
}

.data-panel .van-panel__header .van-panel__desc {
  color: #7d7e80;
  font-size: 12px;
}

.button-container {
  padding: 12px;
  text-align: center;
}

.password-container {
  padding: 40px 20px;
  text-align: center;
}

.logo {
  margin-bottom: 20px;
}

.login-title {
  font-size: 20px;
  color: #1989fa;
  margin-bottom: 8px;
}

.login-subtitle {
  font-size: 14px;
  color: #969799;
  margin-bottom: 20px;
}

.ai-data-container {
  background-color: white;
}

.van-cell {
  align-items: center;
}

.van-cell__title {
  flex: 2;
}

.van-cell__value {
  flex: 1;
  text-align: right;
  color: #1989fa;
  font-weight: bold;
}

.van-cell__label {
  color: #969799;
  font-size: 12px;
}

.total-cell {
  background-color: #f5f5f5;
}

.total-cell .van-cell__title {
  font-weight: bold;
}
</style>
